import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MAIN_CONTENT_ID = 'main-content';

const scrollToPageTop = () => {
  const scrollOptions: ScrollToOptions = { top: 0, left: 0, behavior: 'auto' };

  window.scrollTo(scrollOptions);
  document.scrollingElement?.scrollTo(scrollOptions);
};

const focusMainContent = () => {
  const mainContent = document.getElementById(MAIN_CONTENT_ID);

  if (mainContent instanceof HTMLElement) {
    mainContent.focus({ preventScroll: true });
  }
};

const RouteChangeReset = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      scrollToPageTop();
      focusMainContent();
    });

    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [pathname, search]);

  return null;
};

export default RouteChangeReset;
